import { makeStyles } from '@material-ui/styles'

export default makeStyles(theme => ({
  pl: {
    paddingLeft: theme.spacing(1)
  },
  statusChip: {
    cursor: 'pointer'
  },
  chipSuccess: {
    backgroundColor: theme.palette.success.light
  },
  chipError: {
    backgroundColor: theme.palette.error.light
  },
  fatButton: {
    padding: theme.spacing(1.9)
  },
  drawer: {
    backgroundColor: '#F0F3F7',
    [theme.breakpoints.down('xs')]: { width: '100%' },
    [theme.breakpoints.up('sm')]: { width: '90%' },
    [theme.breakpoints.up('md')]: { width: '75%' },
    [theme.breakpoints.up('lg')]: { width: '60%' },
    [theme.breakpoints.up('xl')]: { width: '50%' },
    padding: '0 30px'
  },
  drawerToolbar: {
    padding: '10px 5px'
  },
  toastsContainer: {
    width: 400,
    marginTop: theme.spacing(6),
    right: 0
  },
  notification: {
    display: 'flex',
    alignItems: 'center',
    background: 'transparent',
    boxShadow: 'none',
    overflow: 'visible'
  },
  notificationComponent: {
    paddingRight: theme.spacing(4)
  },
  progress: {
    visibility: 'hidden'
  },
  notificationCloseButton: {
    position: 'absolute',
    right: theme.spacing(2)
  }
}))
